import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppActions } from '@/app/appContext';

/**
 * Portfolio drill-down: select a branch and jump into one of its single-branch
 * pages. Overrides the previously-picked branch in app state and clears the
 * per-branch camera state — otherwise the target page would re-sync the URL
 * back to the old zone. `extraParams` carries page state through the jump
 * (e.g. the report's z=day|week + date).
 */
export function useOpenZone() {
  const navigate = useNavigate();
  const { setZone, setCamera, setSelectedCamera, setFrame } = useAppActions();
  return useCallback(
    (zoneId: string, pathname: string, extraParams?: Record<string, string>) => {
      setZone(zoneId);
      setCamera('');
      setSelectedCamera(null);
      setFrame(null);
      const params = new URLSearchParams(extraParams);
      params.set('zone', zoneId);
      navigate(`${pathname}?${params.toString()}`);
    },
    [navigate, setZone, setCamera, setSelectedCamera, setFrame],
  );
}
